/** Four decimals, the precision the facts table uses for observation locations. */
export function formatCoordinates(latitude: number, longitude: number): string {
  return `${latitude.toFixed(4)}, ${longitude.toFixed(4)}`;
}

const GOOGLE_MAPS_SATELLITE_ZOOM = 18;

/**
 * Google Maps opened in satellite view with a pin on the point. The documented Maps URLs API
 * (`api=1&basemap=satellite`) can centre on a point but cannot drop a pin, and a bare field with no
 * marker is useless, so this uses the `/place/…/data=!3m1!1e3` form Google Maps itself produces
 * (`!1e3` = satellite). Undocumented, like the `/maps/search/` links elsewhere in the app.
 */
export function googleMapsSatelliteUrl(latitude: number, longitude: number): string {
  const point = `${latitude},${longitude}`;
  return `https://www.google.com/maps/place/${point}/@${point},${GOOGLE_MAPS_SATELLITE_ZOOM}z/data=!3m1!1e3`;
}
